import React from 'react';
import classes from './HeaderChildren.module.scss';
import {Button, Link} from "stories";

const HeaderChildren = ({linkedTo}) => {
    const buttonLabelDict = {
        '/sign-in': 'Sign In',
        '/sign-up': 'Sign Up'
    }
    const menuItems = [
        // {
        //     title: 'Borrowers',
        //     path: '#'
        // },
        {
            title: 'Brokers',
            path: '#'
        },
        // {
        //     title: 'Lenders',
        //     path: '#',
        // },
        {
            title: 'Contact Us',
            path: '#'
        }
    ];
    return (
        <div className={'d-flex align-items-center'}>
            <ul className={classes['menu']}>
                {
                    menuItems.map(item =>
                        <li key={item.title}>
                            <Link type={'secondary'} to={item.path}>{item.title}</Link>
                        </li>
                    )
                }
            </ul>
            <div className={classes['button-wrapper']}>
                <Link to={`${linkedTo}`}>
                    <Button outline variant={'secondary'} label={buttonLabelDict[linkedTo]}/>
                </Link>
            </div>
        </div>
    );
};

export default HeaderChildren;